import { gql } from '@apollo/client';
import {
  CORE_PROJECT_TYPE_FIELDS,
  CORE_FACULTY_FIELDS,
  CORE_PROJECT_CATEGORY_FIELDS,
} from './fragments';

export const GET_PROJECTS = gql`
  query GET_PROJECTS(
    $ids: [ID!]
    $status: Status
    $keyword: String
    $projectDuration: ProjectDurationInput
    $departments: [ID!]
    $faculties: [ID!]
    $projectCategories: [ID!]
    $projectStatus: [ID!]
    $teamMember: ID
    $approvedFundingSource: ID
    $additionalFundingSource: ID
    $current: Int
    $pageSize: Int
    $sort: ProjectsSortInput
  ) {
    projects(
      ids: $ids
      status: $status
      keyword: $keyword
      projectDuration: $projectDuration
      departments: $departments
      faculties: $faculties
      projectCategories: $projectCategories
      projectStatus: $projectStatus
      teamMember: $teamMember
      approvedFundingSource: $approvedFundingSource
      additionalFundingSource: $additionalFundingSource
      current: $current
      pageSize: $pageSize
      sort: $sort
    ) {
      totalCount
      nodes {
        id
        title
        projectCategory {
          id
          name
        }
        projectStatus {
          id
          name
          controlType
        }
        profile {
          projectCode
          workProgramme
          originalStartDate
          originalCompletionDate
          lastApprovedCompletionDate
          department {
            id
            name
            abbreviation
            faculty {
              name
              abbreviation
            }
          }
        }
      }
    }
  }
`;

export const GET_PROJECT_PROFILE = gql`
  ${CORE_PROJECT_TYPE_FIELDS}
  ${CORE_FACULTY_FIELDS}
  ${CORE_PROJECT_CATEGORY_FIELDS}
  query getProjectProfile($ids: [ID!], $status: Status) {
    projects(ids: $ids, status: $status) {
      nodes {
        id
        title
        projectCategory {
          id
          name
        }
        projectStatus {
          id
          name
        }
        projectBudget {
          total
        }
        profile {
          projectType {
            id
            name
          }
          researchRelated
          projectCode
          department {
            id
            name
            faculty {
              id
              name
            }
          }
          accountCode
          accountSetUpDate
          accountClosedDate
          workProgramme
          originalStartDate
          originalCompletionDate
          actualStartDate
          actualCompletionDate
          deadlineOfUsingUpFunding
          lastApprovedCompletionDate
          totalFunding
          totalAdditionalFunding
          approvedFunding {
            amount
            source {
              id
              name
            }
            conditionOfAllocation
          }
          additionalFunding {
            amount
            source {
              id
              name
            }
            conditionOfAllocation
          }
          proposal {
            id
            filename
          }
          supplements {
            id
            filename
          }
          historyLog
          historyLogByPMS
        }
      }
    }
    projectCategories {
      ...CoreProjectCategoryFields
    }
    faculties {
      ...CoreFacultyFields
    }
    projectTypes {
      ...CoreProjectTypeFields
    }
  }
`;

export const GET_PROJECTS_FOR_ANNUAL_REPORT = gql`
  fragment Data on Project {
    id
    title
    projectStatus {
      id
      name
      controlType
    }

    projectCategory {
      name
    }
    profile {
      projectCode
      totalFunding
      workProgramme
      originalStartDate
      actualCompletionDate
      originalCompletionDate
      lastApprovedCompletionDate
      department {
        id
        name
        abbreviation
        faculty {
          id
          name
          abbreviation
        }
      }
    }
    completionReport {
      id
      actualSubmissionDate
    }
    extensionObtained
    latestProgressReport {
      id
      actualSubmissionDate
    }
  }

  query GET_PROJECTS_FOR_ANNUAL_REPORT(
    $projectCategories: [ID!]
    $faculties: [ID!]
    $departments: [ID!]
  ) {
    projectsForAnnualReport(
      projectCategories: $projectCategories
      faculties: $faculties
      departments: $departments
    ) {
      inProgress {
        ...Data
      }
      completed {
        ...Data
      }
    }
  }
`;

export const GET_PROJECT_STATUS = gql`
  query GET_PROJECT_STATUS($ids: [ID!]) {
    projects(ids: $ids) {
      nodes {
        id
        projectStatus {
          id
          controlType
        }
      }
    }
  }
`;

export const ADD_PROJECT = gql`
  mutation addProject($input: AddProjectInput!) {
    addProject(input: $input) {
      id
      title
    }
  }
`;

export const UPDATE_PROJECT_PROFILE = gql`
  mutation updateProjectProfile($input: UpdateProjectProfileInput!) {
    updateProjectProfile(input: $input) {
      id
      projectStatus {
        id
        name
      }
      title
    }
  }
`;

export const GET_PROJECTS_FOR_BULK_DOWNLOAD = gql`
  query GET_PROJECTS_FOR_BULK_DOWNLOAD($ids: [ID!]) {
    projects(ids: $ids) {
      nodes {
        id
        profile {
          projectCode
          proposal {
            id
          }
          supplements {
            id
          }
        }
        extensions {
          id
          progressReport {
            id
          }
          supplements {
            id
          }
        }
      }
    }
  }
`;
